import {
  TableContainer,
  Table,
  TableCaption,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { ImportTransaction } from "data";

export function TransactionList(props: { transactions: ImportTransaction[] }) {
  const { transactions } = props;
  
  return (
    <TableContainer overflowY="scroll" height={"600"}>
      <Table variant="simple" size="sm">
        <TableCaption>List of transaction to import</TableCaption>
        <Thead>
          <Tr>
            <Th>Timestamp</Th>
            <Th>comment</Th>
            <Th isNumeric>Amount</Th>
          </Tr>
        </Thead>
        <Tbody>
          {transactions.map((t, index) => (
            <Tr key={index}>
              <Td>{t.timestamp}</Td>
              <Td>{t.comment}</Td>
              <Td isNumeric>{t.amount}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
